import React, { useContext } from 'react';

import { useFlag } from '@unleash/proxy-client-react';
import { navigateToSignInPage } from '@wellz/utils';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { FeatureToggle } from 'utils/unleash/toggles';

import { SpecialistContext } from 'context';
import useOnInit from 'hooks/useOnInit';
import { getAwsExports } from 'services/amplify';

const SignOut: React.FC = () => {
  const navigate = useNavigate();
  const { setAuthenticated, setSpecialistInfo, setSpecialistProfessionalInfo } =
    useContext(SpecialistContext);
  const newLoginFlowEnabled = useFlag(FeatureToggle.NewLoginFlow);

  useOnInit(() => {
    const onLogout = async () => {
      setAuthenticated(false);
      setSpecialistInfo(null);
      setSpecialistProfessionalInfo(null);

      localStorage.clear();
      await Auth.signOut();

      if (newLoginFlowEnabled) {
        const config = await getAwsExports();

        navigateToSignInPage({
          clientId: config.aws_user_pools_web_client_id,
        });
      } else {
        navigate('/care-provider/info');
      }
    };

    onLogout();
  });

  return null;
};

export default SignOut;
